<script>
/*
    This mixin gathers functionality shared across all form components:
*/
import Modal from "./Modal";
import InvalidCross from "./InvalidCross";

export default {
  components: {
    InvalidCross,
    Modal,
  },
  data() {
    return {
      modals: [], //list of modals unique to each form component
    };
  },
  methods: {
    /*
      Displays the modal at the same vertical height as the button which triggered this display event (implemented to prevent UX issues with very tall iframes)
    */
    displayModal(event, index) {
      event.preventDefault(); //stops checkboxes from being checked/unchecked when clicking inline question mark icons
      let offsetTop = $(event.target).offset().top;
      let currentModal = this.$el.getElementsByClassName("modal-wrapper")[
        index
      ];
      currentModal.style.top = offsetTop + "px";
      this.$set(this.modals, index, true); //$set is a Vue helper method which changes the value at the given index in an array. Without this Vue won't register changes in an array automatically.
    },

    /*
      Expands the collapsed content (collapseElement) of the component and simultaneously updates the corresponding link icon (collapseLink).
    */
    expandContent(collapseLink, collapseElement) {
      collapseLink.setAttribute("aria-expanded", true);
      collapseElement.classList.add("show");
    },

    /*
      Restricts a text-field input to only allow numbers
    */
    restrictNumber(numberString) {
      let regex = new RegExp("^[0-9]*$");
      if (!regex.test(numberString)) {
        // eslint-disable-next-line
        numberString = numberString.slice(0, numberString.length - 1);
      }
      return numberString;
    },

    /*
      Formats number as currency
    */
    formatCurrency(numberString) {
      console.log(numberString);
      let parsedNumber = Number(
        numberString.replace(/\./g, "").replace(/,/g, ".")
      ).toLocaleString("da-dk");
      return parsedNumber;
    },

    /*
      Validates if the prepopulated field has been edited by the user.
    */
    validateHasChanged(event, hasChanged) {
      if (hasChanged) {
        event.target.setCustomValidity("");
        this.validateRequired(event);
        return;
      }
      event.target.setCustomValidity("not edited");
      event.target.classList.add("is-invalid");
    },

    /*
      Validates 'required' input fields and toggles bootstrap class
    */
    validateRequired(event) {
      event.target.validity.valid
        ? event.target.classList.remove("is-invalid")
        : event.target.classList.add("is-invalid");
    },
    scrollTo(elementId) {
      let durationInMs = 500;
      let options = {};
      this.$scrollTo(elementId, durationInMs, options);
    },
    scrollWithModal(elementId, event, modalIndex) {
      this.scrollTo(elementId)
      this.displayModal(event, modalIndex)
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/shared/components/FormComponentsMixin.vue